import React from 'react';
import ImgOne from '../../images/main-banner/carousel/01.jpg';
import ImgTwo from '../../images/main-banner/carousel/02.jpg';
import ImgThree from '../../images/main-banner/carousel/03.jpg';
import ImgFour from '../../images/main-banner/carousel/04.jpg';
import ImgFive from '../../images/main-banner/carousel/05.jpg';
import ImgSix from '../../images/main-banner/carousel/06.jpg';
import ImgSeven from '../../images/main-banner/carousel/07.jpg';
import ImgEight from '../../images/main-banner/carousel/08.jpg';
import ImgNine from '../../images/main-banner/carousel/09.jpg';
import ImgTen from '../../images/main-banner/carousel/10.jpg';
import ImgEleven from '../../images/main-banner/carousel/11.jpg';

const images = [
  ImgOne, 
  ImgTwo, 
  ImgThree,
  ImgFour,
  ImgFive,
  ImgSix,
  ImgSeven,
  ImgEight,
  ImgNine,
  ImgTen,
  ImgEleven
];

const delay = 8000;

function BannerCarousel() {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );

    return () => {
      resetTimeout();
    };
  }, [index]);

  return (
    <div className="slideshow">
      <div
        className="slideshowSlider"
        style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
      >
        {images.map((backgroundImage, index) => (
          <div
            className="slide"
            key={index}
            style={{ backgroundImage }}
          >
            <img alt="bg" src={backgroundImage}></img>
          </div>
        ))}
      </div>

      <div className="slideshowDots">
        {images.map((_, idx) => (
          <div
            key={idx}
            className={`slideshowDot${index === idx ? " active" : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </div>
    </div>
  );
}

export default BannerCarousel;